var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons__wrapper"},[_c('button',{staticClass:"add-more-files",on:{"click":_vm.onAddMore}},[_vm._v(" Add More Files ")]),_c('button',{staticClass:"edit",on:{"click":_vm.onEdit}},[_vm._v(" "+_vm._s(_vm.isEditing ? 'Cancel' : 'Edit')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }